// Written by `python -B -m workbench.server.panels.vocabulary` from
// workbench/server/panels/spec.py. Change the lists there and run it again.

export const SLOTS = ["main", "sidebar", "inspector", "settings", "record"] as const;
export const AUDIENCES = ["owner", "developer"] as const;
export const BLOCK_KINDS = ["table", "timeline", "form", "card", "markdown", "kv", "thread", "graph", "surface"] as const;
export const ACTION_KINDS = ["submit", "complete"] as const;
export const WAKES = ["none", "on_result", "on_request"] as const;
export const FIELD_TYPES = ["string", "number", "boolean", "choice", "text", "list"] as const;
export const FORMATS = ["text", "number", "time", "status", "ref"] as const;
export const RECORD_STATES = ["running", "working", "stopping", "done", "failed", "stopped", "unknown"] as const;
export const RECORD_SLOT = "record";
export const OWNER_AUDIENCE = "owner";
export const DEVELOPER_AUDIENCE = "developer";
export const NO_WAKE = "none";
